(function () {
  angular.module("pcmCommon")
    .factory("ArrivalTime", [function () {

      const DATETIME_FORMAT = "HH:mm"; //Used internally by the UI datetime widgets

      //class that represents an arrival time
      class ArrivalTime {

        constructor(params) {
          //Whether or not to use earliest/latest arrival time
          this.enabled = false;

          //0 = earliest arrival time, 1 = latest
          this.type =  params.type;

          //The datetime string representation for the arrival time. Format in: 10:15 AM
          this.arrivalTime = "";

          this.checkboxLabel = params.checkboxLabel;

          this.weekDayTimeLabel = params.weekdayTimeLabel;

          if(params.arrivalTime) {
            this.arrivalTime = params.arrivalTime;
            this.enabled = true;
          } else {
            this.arrivalTime = moment().format(DATETIME_FORMAT);
          }

        }

        hasValue() {
          return this.enabled;
        }

        getWsMomentTime() {
          if(this.hasValue()) {
            return moment(this.arrivalTime, DATETIME_FORMAT);
          } else {
            if(this.type === 0) {
              return moment().startOf("day");
            }
            else {
              return moment().endOf("day");
            }
          }
        }

        getWsFormattedTime() {
          return this.getWsMomentTime().format("HH:mm");
        }

        getUIFormattedTime() {
          return this.getWsMomentTime().format("HH:mm");
        }
      }

      return ArrivalTime;
    }]);
})();



// WEBPACK FOOTER //
// ./app/pcm-common/ArrivalTime.module.js